var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.73445 51.7365L0.533877 60.1304C0.459681 60.6514 0.507747 61.1825 0.674274 61.6817C0.8408 62.1809 1.12122 62.6345 1.49334 63.0067C1.86546 63.3788 2.31907 63.6592 2.81828 63.8257C3.3175 63.9923 3.84862 64.0403 4.36962 63.9661L12.7635 62.7655C14.0353 62.5858 17.2233 54.0258 17.2233 54.0258C17.2233 54.0258 18.824 55.3993 19.4786 55.6062C20.8759 56.0471 22.2358 54.6769 22.6937 53.2864L24.0062 47.2767C24.0062 47.2767 25.9631 48.2671 26.6719 48.4129C27.574 48.5994 28.449 48.0432 29.0696 47.4192C29.4425 47.0475 29.7225 46.5932 29.887 46.0931L30.7891 40.4938C30.7891 40.4938 33.0783 41.128 33.8618 41.2196C34.7537 41.3213 35.6219 40.8669 36.2595 40.2259L40.119 36.3698C43.386 37.4285 46.8818 37.565 50.2214 36.7643C53.561 35.9637 56.6149 34.2569 59.0468 31.832C62.5389 28.3309 64.5 23.5877 64.5 18.6426C64.5 13.6976 62.5389 8.95442 59.0468 5.45324C55.5456 1.9611 50.8024 0 45.8574 0C40.9123 0 36.1692 1.9611 32.668 5.45324C30.2424 7.88466 28.5352 10.9385 27.7345 14.2783C26.9339 17.6181 27.0708 21.1141 28.1302 24.381L2.69085 49.817C2.17159 50.3356 1.83579 51.0096 1.73445 51.7365ZM52.8472 11.6528C54.6974 13.5085 55.7364 16.0221 55.7364 18.6426C55.7364 21.2631 54.6974 23.7767 52.8472 25.6324L38.8676 11.6528C40.7233 9.80259 43.2369 8.76359 45.8574 8.76359C48.4779 8.76359 50.9915 9.80259 52.8472 11.6528Z",
    fill: "url(#paint0_linear_3292_21542)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3292_21542",
    x1: -9.65873,
    y1: 51.9111,
    x2: 64.5,
    y2: 51.9111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#EAEA15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "#FF855F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692708,
    stopColor: "#FF454E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833333,
    stopColor: "#BE0EDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869792,
    stopColor: "#AD00FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessKey);
export default __webpack_public_path__ + "static/media/successKey.6482a9f195d6dd7fe196e4e0159b3621.svg";
export { ForwardRef as ReactComponent };